import { Message } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledSection = styled.div`
margin: 20px 0px;
`
export const StyledMessage = styled(Message)`
display: flex;
align-items: center;
width: fit-content;
`
export const CountdownWrapper = styled.div`
margin: auto !important;
 .text {    
  margin-top: 20px;
  margin-bottom: 20px;
 }
`